import restClient from "../restClient";

export const getStates = async () => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`states?pagination[page]=1&pagination[pageSize]=1000`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};
